<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
          <Dialogs  header="Company"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="source">Source</label>
                <Dropdown 
                  id="source" 
                  v-model="source" 
                  :options="sourceList" 
                  optionLabel="value" 
                  placeholder="Select Source" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="pipeline" >Pipeline<span style="color:red">*</span></label>
                <InputText id="pipeline" v-model.trim="pipeline" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="ticketStatus">Ticket Status</label>
                <Dropdown 
                  id="ticketStatus" 
                  v-model="ticketStatus" 
                  :options="ticketStatusList" 
                  optionLabel="value" 
                  placeholder="Select Ticket Status" />
              </div>
            <div class="p-field p-col-12 p-md-6">
                <label for="description">Description</label>
                <Textarea id="description" rows="3" v-model="description"/>
              </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="priority">Priority</label>
              <Dropdown 
                id="priority" 
                v-model="priority" 
                :options="priorityList" 
                optionLabel="value" 
                placeholder="Select Priority" />
            </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button" @click.prevent="addTicketDetails" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewTicketDetails" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Textarea from 'primevue/textarea/Textarea'
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      pipeline: '',
      description: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      createUser: false,
      id: '',
      loading: false,
      columnList: '',
      ticketStatus: null,
      source: null,
      priority: null,
      filters: {}
    }
  },
  methods: {
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    async addTicketDetails() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.pipeline === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'pipeline cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        ticketName: this.name,
        pipeline: this.pipeline,
        ticketStatusID: this.ticketStatus.id,
        ticketStatus: this.ticketStatus.value,
        sourceID: this.source.id,
        source: this.source.value,
        priority: this.priority.value,
        priorityID: this.priority.id,
        description: this.description
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmTicket', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmTicket', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewTicketDetails() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.pipeline === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'pipeline cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        ticketName: this.name,
        pipeline: this.pipeline,
        ticketStatusID: this.ticketStatus.id,
        ticketStatus: this.ticketStatus.value,
        sourceID: this.source.id,
        source: this.source.value,
        priority: this.priority.value,
        priorityID: this.priority.id,
        description: this.description
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmTicket', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCrmTicket(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.name = data.ticketName
      this.source = this.sourceList.find(item => item.id === data.sourceID)
      this.ticketStatus = this.ticketStatusList.find(item => item.id === data.ticketStatusID)
      this.priority = this.priorityList.find(item => item.id === data.priorityID)
      this.description = data.description
      this.pipeline = data.pipeline
      // if (this.openingBalance > 0) {
      //   this.openingDrCr = 'Cr'
      // } else {
      //   this.openingDrCr = 'Dr'
      // }
      if (this.status === undefined) {
        this.status = 'INACTIVE'
      }
      this.openAddDialog()
    },
    reset() {
      this.name = ''
      this.pipeline = ''
      this.address = ''
      this.ticketStatus = null
      this.source = null
      this.priority = null
      this.status = ''
      this.description = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  computed: {
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    priorityList() {
      return this.masterSetupList.filter(item =>
        item.name === 'priority'
      )
    },
    sourceList() {
      return this.masterSetupList.filter(item =>
        item.name === 'source'
      )
    },
    ticketStatusList() {
      return this.masterSetupList.filter(item =>
        item.name === 'ticketStatus'
      )
    }
  },
  mounted() {
    this.masterSetupLists()
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmTicketDetailsDialog.vue?4bf8d03a